module.exports = __webpack_public_path__ + "static/media/remove-account-icon.b88733cb.svg";